var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-2"},[_c('v-btn',{staticClass:"botao-menu",attrs:{"color":"primary","small":"","flat":"","outline":"","id":"processoDigital","href":_vm.processoVirtualUrl,"target":"_blank"}},[_vm._v(" Processo Digital ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }